export default class Intro {
    constructor() {
        this.duration = 800;
        this.scaleKeyframes = { scale: 1.5 };

        this._init();
    }

    _init() {
        this._getEl();
    }

    _getEl() {
        this.$introArr = [...document.querySelectorAll('.js-intro')];
    }

    execLoop() {
        this.$introArr.forEach(($intro, i) => this._setAnimate($intro, i));
    }

    _setAnimate($intro, i) {
        const delay = 500 + i * 200;

        const options = {
            fill: {
                delay: delay,
                duration: this.duration,
                easing: CONFIG.EASING.easeInOutCubic,
                fill: 'forwards',
            },
            scale1: {
                delay: delay,
                duration: this.duration / 2,
                easing: CONFIG.EASING.easeOutCubic,
            },
            scale2: {
                delay: delay + this.duration / 2,
                direction: 'reverse',
                duration: this.duration / 2,
                easing: CONFIG.EASING.easeOutCubic,
            },
        };

        const animateFill = $intro.animate(this._getFillKeyframes(i), options.fill),
            animateScale1 = $intro.animate(this.scaleKeyframes, options.scale1),
            animateScale2 = $intro.animate(this.scaleKeyframes, options.scale2);
    }

    _getFillKeyframes(i) {
        return [
            { offset: 0.25, fill: '#000' },
            { offset: 0.25, fill: CONFIG.COLOR[i] },
            { offset: 1, fill: CONFIG.COLOR[i], rotate: 'y 360deg' },
        ];
    }
}
